import { shutdown } from '@intercom/messenger-js-sdk';
import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from '@app/constants/paths.constant';
import { chatItemsKeys, userTrialPermissionsKeys } from '@data/constants';
import { usePermissions, useTokenUserData } from '@data/hooks';
import {
  clearDynamicQuestionsFiltersStore,
  clearWelcomeMessagesStore,
  clearOptimisticSignUpStore,
  useAppUserStore,
} from '@data/storage';

export const useLogout = () => {
  const { setUser } = useAppUserStore();
  const { userId } = useTokenUserData();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { IS_TRIAL_MANAGER } = usePermissions();

  const logout = (redirect = true) => {
    if (IS_TRIAL_MANAGER) shutdown();
    queryClient.removeQueries({ queryKey: chatItemsKeys.all() });
    queryClient.removeQueries({ queryKey: userTrialPermissionsKeys.all() });
    clearWelcomeMessagesStore();
    clearOptimisticSignUpStore();
    clearDynamicQuestionsFiltersStore();
    setUser(undefined);
    if (redirect) navigate(`/${paths.sign_in}`, { state: { from: location.pathname, userId } });
  };

  return { logout };
};
